export const ORDER_VISIBILITY = Object.freeze({
  STANDARD: 'standard',
  TABLE_ORDER: 'table_order',
  BOTH: 'both'
})

const STANDARD_DELIVERY_TYPES = new Set(['address', 'personal_pick_up'])
const VALID_ORDER_VISIBILITIES = new Set(Object.values(ORDER_VISIBILITY))

export const normalizeOrderVisibility = value =>
  VALID_ORDER_VISIBILITIES.has(value) ? value : ORDER_VISIBILITY.BOTH

export const isCategoryEnabledForCurrentMenu = category => {
  if (!category) return false
  if (typeof category.menuActive === 'boolean') return category.menuActive
  return category.active === true
}

export const isCategoryVisibleForDeliveryType = (category, deliveryType) => {
  if (!category) return false

  const visibility = normalizeOrderVisibility(category.orderVisibility)
  if (visibility === ORDER_VISIBILITY.BOTH) return true
  if (deliveryType === 'table_order') return visibility === ORDER_VISIBILITY.TABLE_ORDER
  if (STANDARD_DELIVERY_TYPES.has(deliveryType)) return visibility === ORDER_VISIBILITY.STANDARD

  // Unknown future order types fail open so a server-side addition cannot erase
  // the current menu before this client understands the new context.
  return true
}
